import { composeIO } from 'react-compose-io'
import { popoverFiltroPedidoComissaoClassificacoesIO } from './PopoverFiltroPedidoComissaoClassificacoes.IO'
import { PopoverFiltroPedidoComissaoClassificacoesView } from './PopoverFiltroPedidoComissaoClassificacoes.View'

export const PopoverFiltroPedidoComissaoClassificacoes = composeIO(PopoverFiltroPedidoComissaoClassificacoesView, popoverFiltroPedidoComissaoClassificacoesIO)
